import React, { Component, Fragment } from 'react';
import { Field } from 'react-final-form';
import moment from 'moment';
import Translate from 'react-translate-component';
import { path } from 'ramda';
import PropTypes from 'prop-types';

import { isEmpty } from 'utils/ramdaAdditions';
import { DATE_FORMATS } from 'constants/dateFormats';
import DatePicker from 'components/common/form/DatePicker';
import TimePicker from 'components/common/form/TimePicker';
import AllDayField from 'components/common/controls/AllDayField';

const getCorrectTimeFromValue = (value) => value
    ? moment(value, DATE_FORMATS.timeFormat).subtract(1, 'minutes').format(DATE_FORMATS.timeFormat)
    : undefined;

const notEqualTimes = (value, form) => {
    const from = path(['details', 'time', 'from'], form);
    const to = path(['details', 'time', 'to'], form);
    return from === to && !!from && !!to ? <Translate content="errors.incorrectInterval" /> : undefined;
};

const isTimeEmpty = ({ timeFrom, timeTo }) => isEmpty(timeFrom) && isEmpty(timeTo);

const required = (value) => !value ? <Translate content='errors.required' /> : undefined;

export default class EventDateTimeFields extends Component {
    static propTypes = {
        change: PropTypes.func.isRequired,
        timeFrom: PropTypes.string,
        timeTo: PropTypes.string,
        disabledDateTo: PropTypes.bool,
        validateDateTo: PropTypes.func,
        validateTimeTo: PropTypes.func,
        onlyDateEditable: PropTypes.bool,
    };

    state = {
        allday: isTimeEmpty(this.props)
    }

    onChangeSwitch = (allday) => {
        this.setState({ allday });
    }

    componentDidUpdate(prevProp, prevState) {
        if (this.state.allday !== prevState.allday) {
            const value = this.state.allday ? '' : null;
            this.props.change('time.to', value);
            this.props.change('time.from', value);
        }
    }

    validateFrom = (value, all) => !this.state.allday && (notEqualTimes(value, all) || required(value, all));
    validateTo = (value, all) => !this.state.allday
        ? required(value, all) || (
            this.props.validateTimeTo ? (notEqualTimes(value, all) || this.props.validateTimeTo(value, all)) : notEqualTimes(value, all)
        )
        : undefined;

    render() {
        const { timeFrom, timeTo, disabledDateTo = false, onlyDateEditable = false, validateDateTo } = this.props;
        const { allday } = this.state;

        return (
            <div>
                <Field
                    name='details.dateTo'
                    component={DatePicker}
                    disabled={disabledDateTo}
                    validate={validateDateTo}
                    label={{ content: 'events.date', required: true }}
                />
                { !onlyDateEditable && (
                    <Fragment>
                        <AllDayField
                            checked={allday}
                            onChange={this.onChangeSwitch}
                        />
                        <Field
                            name='details.time.from'
                            component={TimePicker}
                            validate={this.validateFrom}
                            max={timeTo}
                            hidden={allday}
                            label={{ content: 'events.create.startTime', required: true }}
                        />
                        <Field
                            name='details.time.to'
                            component={TimePicker}
                            hidden={allday}
                            validate={this.validateTo}
                            min={getCorrectTimeFromValue(timeFrom)}
                            label={{ content: 'events.create.endTime', required: true }}
                        />
                    </Fragment>
                )}
            </div>
        )
    }
}
